import React, { useContext, useEffect, useState } from "react";
import { useAuth } from "./Auth";
import axios from "axios";
import { api_url } from "../data";

const appContext = React.createContext();

const Context = ({ children }) => {
  const { requestWithAuth } = useAuth();
  const [user, setUser] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);


  const getAccessToken = () => {
    const token = document.cookie
      .split("; ")
      .find((row) => row.startsWith("accessToken="));
    return token?.split("=")[1];
  };

  

  const getUser = async () => {
    try {
      const data = await requestWithAuth(`/accounts/users/me/`, "GET");
      setUser(data);
      setIsAuthenticated(true);
    } catch (error) {
      console.error("Error fetching users data:", error)
    } finally {
      setAuthChecked(true)
    }
  }

  useEffect(() => {
    const token = getAccessToken();
  
    if (token) {
      axios
        .post(`${api_url}/auth/verify/`,{
          token: token
        })
        .then((res) => {
          getUser();
        })
        .catch((err) => {
          setIsAuthenticated(false);
          setAuthChecked(true)
          document.cookie =
            "accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        });
    }else{
      setAuthChecked(true)
    }
  }, []);
  

 
  return (
    <appContext.Provider
      value={{
        isSidebarOpen,
        setIsSidebarOpen,
        isAuthenticated,
        authChecked,
        user,
      }}
    >
      {children}
    </appContext.Provider>
  );
};

const useGlobalContext = () => {
  return useContext(appContext);
};

export { Context, useGlobalContext };
